import {
  type FrontendOnlyColumn,
  type TableColumnConfig,
  type TableValueFormattingContext,
  pickTableColumnConfig,
} from '@ipfabric/utils';
import type { TableCellContext } from 'components/Table/model/TableCellContext';
import type React from 'react';

export type FrontendOnlyColumnRenderFunction<TRow> = (
  row: TRow,
  cellContext: TableCellContext,
) => React.ReactNode;

export const createFrontendOnlyColumn = <TRow,>(
  config: TableColumnConfig & {
    render: FrontendOnlyColumnRenderFunction<TRow>;
    key: string;
    csvStringDependencies?: (keyof TRow)[];
    toCsvString?: (row: TRow, context: TableValueFormattingContext) => string;
    webDependencies?: (keyof TRow)[];
    className?: string;
  },
): FrontendOnlyColumn<TRow> => ({
  ...pickTableColumnConfig(config),
  format: {
    type: 'frontendOnly',
    render: config.render,
    className: config.className,
  },
  csvStringDependencies: config.csvStringDependencies ?? [],
  toCsvString: config.toCsvString ?? (() => ''),
  webDependencies: config.webDependencies ?? [],
});
